import React from 'react';
import { Button, Form } from 'antd';
import styles from './index.module.scss';
import PasswordLoginPriv, { IFormStore } from 'lib/publicUsecase/PasswordLoginPriv';
import { noop } from 'lodash';
import LoginAgreementItem from 'component/AuthForm/LoginAgreementItem';
import LoginGraphicCapatchaItem from 'component/AuthForm/LoginGraphicCapatchaItem';
import LoginAccountItem from 'component/AuthForm/LoginAccountItem';
import LoginPasswordItem from 'component/AuthForm/LoginPasswordItem';
import { useDispatch } from 'react-redux';
import { afterLogin } from 'model/login';

interface IProps {}

const LoginWithPassword: React.FunctionComponent<IProps> = () => {
  const [form] = Form.useForm<IFormStore>();
  const dispatch = useDispatch();

  function onFieldsChange() {
    const newData = form.getFieldsValue();
    passwordLogin.formStore.set(newData);
  }

  const passwordLogin = new PasswordLoginPriv();

  const stateData = passwordLogin.stateStore.value;
  const formData = passwordLogin.formStore.value;

  async function handlePasswordLogin() {
    const res = await form.validateFields().catch(noop);
    if (!res) return;

    // 注册校验
    const isRegistered = await passwordLogin.checkUserRegistered();
    if (!isRegistered) return;

    const data = await passwordLogin.fetchPasswordLogin();
    if (!data) return;
    console.log('data', data);
    // 登录成功后跳转
    dispatch(
      afterLogin({
        token: data.access_token,
        userId: data.userId,
        mobile: formData.mobile
      })
    );
  }

  async function handlePasswordRegister() {
    const res = await form.validateFields().catch(noop);
    if (!res) return;
    const data = await passwordLogin.fetchPasswordRegister();
    if (!data) return;
    // 登录成功后跳转
    dispatch(
      afterLogin({
        token: data.access_token,
        userId: data.userId,
        mobile: formData.mobile
      })
    );
  }

  const { mobile, password, confirmPassword, graphicCaptcha } = form.getFieldsValue();
  const btnEnable = mobile && password && (stateData.isUserRegistered || confirmPassword) && (!stateData.graphicCaptchaUrl || graphicCaptcha);

  return (
    <div className={styles.main}>
      <div className={styles.mainTitleContainer}>
        <div className={styles.mainTitle}>账号登录</div>
      </div>
      <div className={styles.formWrapper}>
        <Form form={form} onFieldsChange={onFieldsChange} initialValues={formData}>
          <LoginAccountItem name="mobile" help={stateData.accountError} onChange={passwordLogin.handleUserNameChange} />
          <LoginPasswordItem name="password" help={stateData.passwordError} type="login" />
          {!stateData.isUserRegistered && <LoginPasswordItem name="confirmPassword" type="confirm" />}
          <LoginGraphicCapatchaItem
            name="graphicCaptcha"
            help={stateData.graphicCaptchaError}
            onReset={passwordLogin.refrashGraphicCaptchaUrl}
            src={stateData.graphicCaptchaUrl}
          />
          <div className={styles.buttonWrapper}>
            <Button
              disabled={!btnEnable}
              loading={stateData.btnLoading}
              type="primary"
              block
              size="large"
              htmlType="submit"
              onClick={stateData.isUserRegistered ? handlePasswordLogin : handlePasswordRegister}
            >
              登录/注册
            </Button>
          </div>
          <LoginAgreementItem name="agreement" />
        </Form>
      </div>
    </div>
  );
};

export default LoginWithPassword;
